<template>
    <div class="commute">
        <button class="green" v-for="commute in other_commutes_unique" v-if="commute.number < this_commute_number
        && this_commute_number > 1
        && commute['data']['commute_dist_time']['data_complete']"
        @click="copy(commute)"
        >{{ $t('commute.dist-time.copy-from', {commute_number: commute['number']}) }}
        <span v-html="convert('vehicleIcon', commute, '18', 'white')"></span>
        </button>
    </div>    
</template>

<script>

import conversions from '../conversions.js'
 
export default {
    components: {
         
    },
    data: function(){
        return {

        }
    },
    mounted() {
    
    },
    props: {
        this_commute_number: {
            type: Number,
            default: 0
        },
        other_commutes: {
            type: Array,
            default: function () {
                return []
            }
        },
        
    },
    computed: {
        other_commutes_unique: function(){
            let ocu = []
            let keys = []
            for(let c in this.other_commutes){
                let k = JSON.parse(JSON.stringify(this.other_commutes[c].data.commute_dist_time))
                if(k['data_complete']){

                    k['mapcontainersrc'] = ""

                    k = JSON.stringify(k)

                    //console.log('other_commutes_unique c='+c)
                    //console.log(k)
                    
                    if(!keys.includes(k)){
                        keys.push(k)
                        ocu.push(this.other_commutes[c])
                    }
                    //console.log(keys)
                }
            }
            return ocu
        }
    },
    methods: {
        copy: function(commute){
            this.$emit('copy_to', {
                commute_number: this.this_commute_number,
                commute: commute['data']})
        },
        convert : function(fn, ...args){
            return conversions[fn](...args);
        }

    }
}
    

</script>

<style>

</style>